import React,{useState,useEffect} from 'react'
import { Box, IconButton, Table, TableBody, Tooltip,
    TableContainer, TableHead, TableRow,    
} from '@mui/material';
import { makeStyles } from 'tss-react/mui'
import moment from 'moment';
import {celda} from '../../Generales/TablaGeneral';
import { printConsole } from '../../funciones/ConsolaLog';
import NuevoContrato from '../Contrato/NuevoContrato';
import {AddCircleOutline} from '@mui/icons-material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import EditarContrato from './EditarContrato';
import CreateIcon from '@mui/icons-material/Create';
const useStyles = makeStyles()((theme) => {
    return {
        root: {
            width: '50rem',
        },
        container: {
            maxHeight: 420,
            width: '50rem',
        },
        tableRow: {
            "&$selected, &$selected:hover": {
                backgroundColor: "#F46239"
            }
        },
        tableCell: {
            "$selected &": {
                color: "white"
            }
        },
        hover: {},
        selected: {}
    };
  });

const TablaContrato = ({datos,setContrato,Buscar}) => {
    const classes = useStyles();
    const [selectedID, setSelectedID] = useState(null);
    const [modalNvoContrato,setModalNvoContrato]= useState(false);
    const [modalEditContrato,setModalEditContrato]= useState(false);
    useEffect(() => {
        printConsole(datos)
    
    
    }, [ ])
 
    function Row(props) {
        const {row} = props;
        let nomPdf=row.Pdf.length!==0 ? row.Pdf.substring(row.Pdf.lastIndexOf('/')+1,row.Pdf.length):""
        return (           
        <TableRow  selected={selectedID?.Id === row.Id} 
            classes={{hover: classes.hover, selected: classes.selected}}
            className={classes.tableRow}    
            onClick={() => { 
                setSelectedID(row) 
                setContrato(row) }}                     
        >   
            {  celda("center", { },       
                <Tooltip title="Editar Contrato">
                <IconButton size="small" onClick={()=>{setModalEditContrato(true)}}   >
                    <CreateIcon/>
                </IconButton>              
                </Tooltip>         
            , 1, classes.tableCell)  }                  
            {  celda("center", { },  
                row.Pdf.length!==0?
                <a href={row.Pdf}> ​​​​​​​​ 
                    <Tooltip title={`Descargar ${nomPdf}`}>
                    <IconButton size="small"  >
                        <PictureAsPdfIcon/>
                    </IconButton>
                    </Tooltip>
                </a>:null
                , 2, classes.tableCell)  }            
            {celda("center", {width: 45+'px'}, 
                row.Id
            , 3, classes.tableCell)}  
            {celda("center", {width: 45+'px'}, 
                row.Fini=== "1900-01-01 00:00" ? 
                "" : moment.utc( row.Fini).format('DD/MM/YYYY')
            , 4, classes.tableCell)}   
            {celda("center", {width: 45+'px'}, 
                row.Ffin=== "1900-01-01 00:00" ? 
                "" : moment.utc( row.Ffin).format('DD/MM/YYYY')
            , 5, classes.tableCell)}      
            {celda("center", {width: 45+'px'}, 
                row.Ffirma=== "1900-01-01 00:00" ? 
                "" : moment.utc( row.Ffirma).format('DD/MM/YYYY')
            , 6, classes.tableCell)}                          
            {celda("left", {}, row.InterNom, 10, classes.tableCell)}
            {celda("left", {}, row.Representante, 7, classes.tableCell)}
            {celda("left", {}, row.Descr, 8, classes.tableCell)}
            {celda("left", {}, row.Observ, 9, classes.tableCell)}
        </TableRow>                          
        );
    }

const tablaCompleta = () => {

    return (
    <TableContainer className={classes.container}>
    <Table stickyHeader aria-label="sticky table">
        <TableHead>
            <TableRow>
                {celda("center", {}, datos.length , 1, "") }
                {celda("left", {},  
                 <Tooltip title="Agregar Contrato">
                 <IconButton onClick={()=>{setModalNvoContrato(true)}} size="small" >
                    <AddCircleOutline />
                </IconButton>
                </Tooltip>
                , 2, "")}                           
                {celda("center", {}, "Folio", 3, "") }     
                {celda("center", {}, "F.Inicio",4, "")}   
                {celda("center", {}, "F.Fin",5, "")}     
                {celda("center", {}, "F.Firma",6, "")}     
                {celda("center", {}, "Interprete", 10, "")}
                {celda("center", {}, "Representante", 7, "")}
                {celda("center", {}, "Descripción", 8, "")}
                {celda("center", {}, "Observaciones",9, "")}
                                                                                            
            </TableRow>
        </TableHead>
        <TableBody>                                                                 
            {datos.length !== 0  ? 
                (datos.map((row) => (
                    <Row key={row.Id} row={row}/>
                ))) 
            : 
            <TableRow className={classes.tableRow} >            
                {celda("center", {}, "", 1, classes.tableCell)}
                {celda("center", {}, "", 2, classes.tableCell)}
                {celda("center", {}, "Sin", 3, classes.tableCell)}
                {celda("center", {}, "", 4, classes.tableCell)}
                {celda("center", {}, "", 5, classes.tableCell)}
                {celda("center", {}, "Registros", 6, classes.tableCell)}
                {celda("center", {}, "", 7, classes.tableCell)}
                {celda("center", {}, "", 8, classes.tableCell)}
            </TableRow>       
            }
        </TableBody>
    </Table>
    </TableContainer>
    )
    }

    const modNvoContrato= modalNvoContrato ? <NuevoContrato modalAbierto={modalNvoContrato} Buscar={Buscar}
                                                setModalAbierto={setModalNvoContrato} registro={selectedID} /> :null
    const modEditContrato= modalEditContrato ? <EditarContrato modalAbierto={modalEditContrato} Buscar={Buscar}
                                                setModalAbierto={setModalEditContrato} registro={selectedID} /> :null                                                
  return (
    <Box>
        {modNvoContrato}
        {modEditContrato}
        {tablaCompleta()}
    </Box>
  )
}

export default TablaContrato